import clsx from 'clsx'
import { unsafeCSS } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { html } from 'lit/static-html.js'

import { DdsElement } from '@/internal/dds-hu-element'
import { SizedMixin } from '@/internal/mixin/sizedMixin'

import styles from './_styles/card-actions.scss?inline'

/**
 * `dap-ds-card-actions`
 * @summary A card actions is a container for actions in a card.
 * @element dap-ds-card-actions
 * @title - Card actions
 * @group card
 *
 * @property {'sm' | 'md' | 'lg'} size - The size of the card actions. Default is `sm`.
 * @property {'top' | 'bottom' | 'both' | 'none'} spacing - The spacing of the card actions. This adds a margin to the card actions. Default is `bottom`.
 *
 * @slot - The content of the card actions.
 *
 * @csspart base - The main card actions container.
 *
 * @cssproperty --dds-card-actions-gap - The gap between items in the card actions. Default is `var(--dds-spacing-200)`.
 * @cssproperty --dds-card-actions-padding-lg - The padding for large size card actions. Default is `var(--dds-spacing-600)`.
 * @cssproperty --dds-card-actions-padding-md - The padding for medium size card actions. Default is `var(--dds-spacing-400)`.
 * @cssproperty --dds-card-actions-padding-sm - The padding for small size card actions. Default is `var(--dds-spacing-400)`.
 * @cssproperty --dds-card-actions-margin-lg - The margin for large size card actions spacing. Default is `var(--dds-spacing-600)`.
 * @cssproperty --dds-card-actions-margin-md - The margin for medium size card actions spacing. Default is `var(--dds-spacing-400)`.
 * @cssproperty --dds-card-actions-margin-sm - The margin for small size card actions spacing. Default is `var(--dds-spacing-400)`.
 */
@customElement('dap-ds-card-actions')
export default class DapDSCardActions extends SizedMixin(DdsElement) {
  /** Whether the card actions should be sized from the parent. */
  @property() parentSized: string = 'true'

  static readonly styles = unsafeCSS(styles)

  constructor() {
    super()
    this.spacing = 'bottom'
  }

  render() {
    return html`
      <div
        part="base"
        class=${clsx(
          'card-actions',
          `card-actions--${this.size}`,
          `card-actions-spacing--${this.spacing}`,
        )}>
        <slot> </slot>
      </div>
    `
  }
}
